/* eslint-disable */

import { observable, computed, observe } from 'mobx';
import { store } from '../stores/mainStore';
import { comm } from "../comm";
import { i18n } from '../i18n';
import { integration } from '../integration';

export class Manager{

	constructor(){
		console.log('new manager', this);
		this.music = null;
		this.DEV_VERSION = false;
		console.log('MANAGER INIT');
		console.log('window.hostname: '+window.location.hostname);
		if(window.location.hostname.search("sa-dev") || window.location.hostname.search("sa-qa") || window.location.hostname === "localhost") {
			this.DEV_VERSION = true;
			console.log("RUNNING DEV OR QA LINK");
		}
		this.init();
		// window.addEventListener('blur', () => {
		// 	//console.log('lost focus');
		// 	if(window.location.hostname !== 'localhost' && this.scene && this.scene.scene && this.scene.scene.pause){
		// 		this.scene.scene.pause();
		// 		store.modal = 'blur';
		// 	}
		// });
		// window.addEventListener('focus', () => {
		// 	//console.log('gained focus');
		// 	if(window.location.hostname !== 'localhost' && this.scene && this.scene.scene && this.scene.scene.resume){
		// 		this.scene.scene.resume();
		// 		if(store.modal === 'blur'){
		// 			store.modal = '';
		// 		}
		// 	}
		// });

	}

	init = () => {
		if(this.sceneRestarting === true)
			return;

		this.config = null;
		this.game = null;
		this.scene = null;
		this.createScene = null;

		this.diceHand = null;
		this.cup = null;
		this.handHelp = null;
		this.skipTutorial = null;

		this.gameHudLevelText = null;
		this.handPointerTimer = null;
		this.cupSwirlTimer = null;
		this.cupDragAutoFireTimer = null;
		this.rollBannerTimer = null;

		this.assetURL = '/assets';
		this.scoreCardElements = [];
		this.scoreCardHands = [];
		this.scoreCardOpponentHands = [];
		this.gamesStarted = 0;
		this.pushDownAmount = 12;
		this.pinkHeart = null;
		this.heartText = null;
		this.text = null;
		this.rollInfo = null;
		this.handText = null;
		this.arrow = null;
		this.readyToLaunch = false;
		this.observer1 = null;
		this.observer2 = null;
		this.observer3 = null;
		this.soundObserver = null;
		this.diceTinyScale = 0.1 * 2;// * (128/256);
		this.handBannerHandNames = ["blank", 'two-pair', 'three-of-a-kind', 'straight', 'flush', 'full-house', 'four-of-a-kind', 'straight-flush', 'royal-flush', 'five-of-a-kind'];
		this.dicePerHandType = [0, 4, 3, 5, 5, 5, 4, 5, 5, 5];
		this.scoreCardContainer = null;
		this.scoreCardHeader = null;
		this.scoreCardFooter = null;
		this.bannerContainer = null;
		this.resultsBanner = null;
		this.scoreCardBanner = null;
		this.lowerBonusLeft = null;
		this.lowerBonusRight = null;
		this.upperBonusLeft = null;
		this.upperBonusRight = null;
		this.finalScoreLeft = null;
		this.finalScoreRight = null;
		this.pLeft = null;
		this.pRight = null;
		this.floatingStars = null;
		this.resultsProfilePic = null;
		this.resultsStarsContainer = null;
		this.opponentResultsStarsContainer = null;
		this.resultsProfileShape = null;
		this.resultsOpponentPic = null;
		this.myMatchName = null;
		this.opponentMatchName = null;
		this.myMatchPic = null;
		this.opponentMatchPic = null;
		this.myLevelStar = null;
		this.opponentLevelStar = null;
		this.myMatchRing = null;
		this.opponentMatchRing = null;
		this.scoreCardTweens = [];
		this.zoomerContainer = null;
		this.avaPanel = null;
		this.avaFace = null;
		this.lastZoomedDice = 0;
		this.lastZoomerTween = null;
		this.currentHandObserver = null;
		this.diceReceived = false;
		this.matchPanel = null;
		this.matchBlur = null;
		this.goalArrowTween = null
		this.goalArrowTween2 = null;
		this.handBanner = null;
		this.jackPotText = null;
		this.roundBanner = null;
		this.turnBanner = null;
		this.myTotalScore = 0;
		this.opponentTotalScore = 0;
		this.myLowerBonusScore = 0;
		this.myUpperBonusScore = 0;
		this.opponentLowerBonusScore = 0;
		this.opponentUpperBonusScore = 0;
		// this.portraitBotNum = 0;
		// this.portraitBotName = 'portrait_bot0';
		this.matchesThisSession = 0;
		this.scorehelp = null;
		this.gameHud = null;
		this.gameHudBackButton = null;
		this.gameHudBackCover = null;
		this.gameHudLogoCover = null;
		this.gameState = {state: "idle"};
		this.diceStatus = 'resolved';
		this.playfield = null;
		this.playfieldFrame = null;
		this.playfieldHighPosition = 0;
		this.playfieldLowPosition = 0;
		this.showCupDebugInfo = false;
		// this.sceneRestarting = false;
		this.storeLink = 'https://roll-win.onelink.me/43sq/jsu3b4lm';
		//this.storeLink = store.isHardRock ? 'https://diceparty.onelink.me/SoLB/tta624qn' : 'http://onelink.to/3acgh2';

		this.hands = {
			1:		'high-card'       ,
			2:		'pair'            ,
			3:		'two-pair'        ,
			4:		'three-of-a-kind' ,
			5:		'straight'        ,
			6:		'flush'           ,
			7:		'full-house'      ,
			8:		'four-of-a-kind'  ,
			9:		'five-of-a-kind'  ,
			10:		'six-of-a-kind'   ,
			11:		'straight-flush'  ,
			12:		'royal-flush',
			21:		'three-pair',
			22:		'four-pair',
			31:		'three-straight',
			32:		'four-straight',
			41:		'big-house',
			42:		'two-three-of-a-kind',
			51:		'three-straight-flush',
			52:		'four-straight-flush',
			61:		'all-black',
			62:		'all-red',
			63:		'five-flush-diamonds',
			64:		'five-flush-hearts',
			65:		'five-flush-spades',
			66:		'five-flush-clubs'
			};

	}

	sceneRestarting = false;

	calcDimensions = (config) => {
		this.config = config;
		this.landscape = false; //this.config.width > this.config.height;

		this.xAspectDiff = this.config.width / 480;
		this.yAspectDiff = this.config.height / 852;

		this.scaleFactor = 2;
		this.assetScaleFactor = this.config.width/640;
		this.oldAssetScaleFactor = (480/640)*this.scaleFactor;
		// this.assetScaleFactor *= this.xAspectDiff;

		this.diceOldFullRes = 316;
		this.diceFullRes = 226;
		this.diceResRatio = this.diceFullRes / this.diceOldFullRes;
		this.diceTargetSize = this.landscape ? 95 : 226;
		this.diceBigScale = (this.diceTargetSize/this.diceFullRes);
		this.diceActualWidth = this.diceBigScale * this.diceFullRes;
		this.diceGridPad = this.diceActualWidth * 0.015;
		this.diceTop = this.adjustY(852) * 0.25;
		if(!this.landscape)
			this.diceTop -= 10 * this.scaleFactor;
		this.diceTop += this.pushDownAmount;
		this.diceLeft = config.width / 2 - (this.diceActualWidth + this.diceGridPad);
		this.highlightScale = this.diceBigScale * 1.02 * 2 * this.diceResRatio;// 0.71;

		this.diceEndScale = 0.75 * (100/256) * 1.1;
		this.diceEndScale *= 2;
		this.dice2DSmallScale = ((1.15 * this.diceEndScale) /2) * (this.diceOldFullRes / this.diceFullRes);

		this.aimPoint = {x:config.width/2, y: config.height*0.29};
		this.farthestLaunchPoint = {x: 0, y: config.height};

		this.handBannerPosition = 99*2;// this.adjustY(99);
		this.defaultButtonWidth = 130*2;
	}


	@observable gameState = {state: "idle"};
	@observable diceStatus = 'resolved';

	_handPointer;
	set handPointer(anim){
		if(this._handPointer){
			this._handPointer.destroy();
		}
		this._handPointer = anim;
	}

	get handPointer(){
		return this._handPointer;
	}


	@computed get readyToRoll(){
		return this.diceStatus === 'resolved';
	}

	adjustX(oldX) {
		return oldX * this.xAspectDiff;
	}
	adjustY(oldY) {
		return oldY * this.scaleFactor;// this.yAspectDiff;
	}

	clearOtherStuff() {
		if(this.handBannerBack)
			this.handBannerBack.destroy();
		if(this.handBanner)
			this.handBanner.destroy();
		if(this.handHelp)
			this.handHelp.destroy();
	}
	clearMessages() {
		this.cup.hideCupSwirl();
		this.ui.hideTutorialBanner();
		this.ui.clearAvaPanel();

		if(!store.tutorialMode) {
			if(this.goalArrowTween != null)
				this.goalArrowTween.stop();
			if(this.goalArrowTween2 != null)
				this.goalArrowTween2.stop();
			this.goalArrowTween = null;
			this.goalArrowTween2 = null;
		}
		if(this.zoomerContainer != null) {
			this.zoomerContainer.destroy();
			this.zoomerContainer = null;
		}

		this.scoreCardTweens.forEach(el => el.stop());
		this.scoreCardElements.forEach(el => el.destroy());
		this.scoreCardHands.forEach(el => el.destroy());
		this.scoreCardOpponentHands.forEach(el => el.destroy());

		this.scoreCardElements = [];
		this.scoreCardHands = [];
		this.scoreCardOpponentHands = [];
		this.scoreCardTweens = [];
	}

	startThrow = (pointer) => {
		// this.text.text = "pointerdown";
		this.readyToLaunch = false;

		this.clearMessages();

		// pointCupTowardsAimPoint();
		this.diceHand.sendDiceToCup();
		this.playfieldSetToBottom();

		var heldIndexes = [];
		if(store.activeMatch.currentHand) {
			//TODO: Stop duplicating the source of truth with the dice.
			this.diceHand.dice.forEach((d, i)=>{
				store.activeMatch.currentHand.dice[i].held = d.locked;//!store.activeMatch.currentHand.dice[i].held;
				if(d.locked){
					heldIndexes.push(i);
				}
			});
		}

		this.diceReceived = false;

		// comm.RollDice(heldIndexes);
		//TODO: use the promise from this function to trigger the fact that dice have been received.
		store.activeMatch.currentHand.roll();

		// scene.setTint(0xe0e0e0);
	}

	nextHand() {
		var handNumber = store.activeMatch.handNumber;
		store.activeMatch.nextHand()
		.then(() => {
			this.ui.showScorecard(handNumber, false);
		});
	}

	stopGame = () => {
		this.showCupDebugInfo = false;
		if(this.cup) {
			this.cup.hideCup();
			this.clearMessages();
			this.clearOtherStuff();
		}
		window.gameTimeouts.forEach(t => clearTimeout(t));
		window.gameTimeouts = [];

		// this.sceneRestarting = true;
		// this.scene.scene.restart();
			this.scene.scene.sleep();
		// if(this.sceneRestarting === false) {
		// 	this.game.destroy(true);
		// 	this.game = null;
		// 	store.phaserGameCreated = false;
		// 	// this.init();
		// }
	}

	startGame = () => {
		store.activeDebug = "reactivating";
		this.showCupDebugInfo = false;

		this.setSafeAreaBanners("blue", "blue");

		if(this.sceneRestarting) {

			this.scene.scene.restart();
		}

		if(this.createScene){
			setTimeout(this.createScene, 600);
		} else {
			setTimeout(this.startGame,500);
			return;
		}
		// this.createScene = null;
	}

	// resetGame = () => {
	// 	this.sceneRestarting = true;
	// 	this.scene.scene.restart();

	// 	this.startGame();
	// }

	resetToWaiting = () => {
		this.stopGame();
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				// store.phaserInstanceIndex += 1;
				resolve(this);
			},500);
		})
	}

	onCreateComplete = () => {
		console.log('START GAME CALLED');

		if(!store.activeMatch.viewOnlyMode) {
			//game is loaded and starting and not tutorial; preload an ad for later:
			if(store.enableAds)
				window.WrapperApp.postMessage("load-video");
			}

		this.cup.hideCup();
		store.activeMatch.status = 0;
		this.gamesStarted++;

		if(this.observer1 == null) {
			const disposer = observe(this.gameState, (change) => {
				// console.log(change.type, change.name, "from", change.oldValue, "to", change.object[change.name]);
				// if(change.name == "state" && change.object[change.name] == "roll")
				// 	delayTimer = 10;
			});
			this.observer1 = disposer;
		}

		// if(this.observer3 == null) {
		// 	const disposer3 = observe(store, (change) => {
		// 		console.log(change.type, change.name, "from", change.oldValue, "to", change.object[change.name]);
		// 		// if(change.name == "exitRequestReceived")// && change.object[change.name] == "true")
		// 			// integration.exitGame();
		// 			// this.clearMessages();
		// 	});
		// 	this.observer3 = disposer3;
		// }

		if(this.observer2 != null)
			this.observer2();
		// else
		// if(observer2 == null)
		{
			const disposer2 = observe(store.activeMatch, (change) => {
				// console.log(change.type, change.name, "from", change.oldValue, "to", change.object[change.name]);

				// this.updateInfo();

			});
			this.observer2 = disposer2;
		}

		// if(this.soundObserver == null) {
		// 	const disposer = observe(store, (change) => {
		// 		// console.log(change.type, change.name, "from", change.oldValue, "to", change.object[change.name]);
		// 		if(change.name == "soundEnabled") {
		// 			if(store.soundEnabled != false)
		// 				this.startMusic();
		// 			else
		// 				this.stopMusic();
		// 		}
		// 		// 	delayTimer = 10;
		// 	});
		// 	this.soundObserver = disposer;
		// }

		this.addCurrentHandObserver();

		this.updateInfo();

		this.ui.createGameHud();

		this.updateHeartInfo();


		this.ui.userProfilePicLoaded = false;
		this.ui.loadUserProfilePic();

	}

	addCurrentHandObserver() {
		if(this.currentHandObserver != null)
			this.currentHandObserver();
		const disposer3 = observe(store.activeMatch.currentHand, (change) => {
			// console.log(change.type, change.name, "from", change.oldValue, "to", change.object[change.name]);
			if(change.name === "rollNumber") {

				// console.log("ROLLNUMBER CHANGED **************");

				//copy dice to phaser dice
				this.diceReceived = true;
				// this.text.text = "dice received from server";

				this.updateInfo();
				// console.log("currentHand: " + store.activeMatch.currentHand);

				// for(var i=0;i < store.activeMatch.currentHand.dice.length;i++)
				// 	console.log("d"+i+" showing: "+store.activeMatch.currentHand.dice[i].showing);
				// console.log("best: "+store.activeMatch.currentHand.best);
				// console.log("match: "+store.activeMatch.currentHand.match);
			}
			if(change.name === "rollsRemaining")
				if(store.activeMatch.currentHand.rollsRemaining === 1)
					;//console.log("ROLLS REMAINING CHANGED TO 1");
		});
		this.currentHandObserver = disposer3;
	}

	updateInfo() {
		// this.handText.text = this.rollInfo.text = this.text.text = "";
		return;

		// var qs = window.platformUser || {};
		// this.handText.text = "Hand "+store.activeMatch.handNumber + " game.status: "+store.activeMatch.status + " "+store.activeMatch.statusText;

		// this.rollInfo.text = "roll: "+store.activeMatch.currentHand.rollNumber+" remaining: "+store.activeMatch.currentHand.rollsRemaining;

		// this.text.text = `uid: ${qs.playerId} cid: ${qs.casinoId} img: ${qs.imageUrl}
		// Last Bet: ${store.user.lastBetAmount} balance: ${store.user.balance}
		// qs: ${window.location.search}`;// "pointerup";
	}

	getUsername() {
		// var name = (store.user.name !== "" && store.user.name !== " ") ? store.user.name : "You";
		let name = i18n.t("You");
		return name;
	}

	updateHeartInfo() {
		if(this.heartText != null)
			this.heartText.text = store.user.hearts;
	}
	updateLevelInfo() {
		if(window.manager.gameHudLevelText != null)
			window.manager.gameHudLevelText.text = store.user.level;
	}

	rewardVideoAddHearts() {

		comm.WatchAd()
		.then(() => {
			store.user.updateHearts()
			.then(() => {
				integration.postAnalyticsEvent(`reward_earn_heart`, `economy`, store.user.heartsGained);
				store.user.heartAnimComplete();
				window.manager.updateHeartInfo();
			});

		});
	}
	storeRewardVideoAddHearts() {

		comm.WatchAd()
		.then(() => {
			integration.postAnalyticsEvent(`reward_earn_heart`, `economy`, 1);//store.user.heartsGained);
			store.purchaseComplete = true;
		});

	}

	processRewardAdClosed() {
		integration.postAnalyticsEvent(`reward_watch_ad_store`, `economy`);
		if(store.rewardAdModalHearts === -1) {	//it was in-game when out of hearts

			comm.WatchAd()
			.then(() => {
				store.modal = ''; //undim screen
				store.user.updateHearts()
				.then(() => {

					comm.UseFreeRoll(store.activeMatch.matchId).then(() => {
						// store.activeMatch.useHeart();

						store.activeMatch.currentHand.rollsRemaining = 1;
						this.clearMessages();
						this.cup.returnCup();
						// store.user.heartAnimComplete();
						// m.updateHeartInfo();
						this.ui.finishExtraRoll();

					}).catch(err => {
						console.log("comm.canUseFreeRoll err:"+err);
					});

				});
			});

		} else {
			store.rewardAdModalHearts = 1;
			if(store.autoOpenModalAfterAd){
				integration.postAnalyticsEvent(`store_watch_ad_complete`, `economy`);
				// store.modal = 'rewardVideo';
				window.manager.storeRewardVideoAddHearts();
			} else {
				store.modal = ''; //undim screen
				store.autoOpenModalAfterAd = true;
			}
		}
	}

	showInterstitialVideo() {

		// if(store.tutorialMode)
		// 	return false;
		// window.WrapperApp.postMessage("show-video");
		// store.turnsSinceLastAdView = 0;
		// return true;

		if(store.firstLaunchUtcSecs === '')
			return false;
		var d = Date.now() / 1000;
		var f = store.firstLaunchUtcSecs === '' ? '1601945733' : store.firstLaunchUtcSecs;
		console.log(":::::::::::::::::::: DATE NOW: "+d+" first Launch UTC: "+f);
		var elapsedSecs = d - parseInt(f);
		var elapsedMins = elapsedSecs / 60;
		var elapsedHours = elapsedSecs / (60 * 60);
		console.log("ELAPSED HOURS: "+elapsedHours+" MINS "+elapsedMins+" ELAPSED SECS " + elapsedSecs);

		// if(store.videoAdIsLoaded) {
		// 	window.WrapperApp.postMessage("show-video");
		// 	return true;
		// } else
		// 	return false;

		let minMins = 24 * 60;
		if(elapsedMins < minMins || store.user.level < 4 || store.hasPurchasedIAP === 'true')
			return false;

		if(store.enableAds) {
			let timeToShow =
				((store.activeMatch.handNumber === 1 && store.activeMatch.opponent.isBot) || (store.activeMatch.handNumber === 7 && !store.activeMatch.opponent.isBot))
			if(!timeToShow)
				return false;
			let showVideo = store.videoAdIsLoaded && store.turnsThisSession > 0 && store.turnsSinceLastAdView >= 3;// && store.user.level >= 4;
			if(showVideo) {
				window.WrapperApp.postMessage("show-video");
				store.turnsSinceLastAdView = 0;
				return true;
			}
		}
		return false;
	}
	showRewardVideoModal() {
		// integration.postAnalyticsEvent('store_purchase_hearts', 'navigaton', store.user.hearts);
		store.rewardAdModalHearts = 0;// store.rewardAdIsLoaded ? 0 : 2;
		store.modal = 'rewardVideo';
	}
	showProductStore() {
		integration.postAnalyticsEvent('store_purchase_hearts', 'economy', store.user.hearts);

		//reset store data
		store.products = [];
		store.productStoreReady = false; //order is important here
		store.showProductStore = true; //TODO: fix this because it is brittle

		if(window.location.hostname === "localhost" || window.location.hash === '#dev'){
			//fake products for local development
			let product1 = {productId:"HEARTS_1_6_H460",title:"A BOATLOAD (Shake It Up)", description:"of Bonus Hearts!", price:"$4.99"};
			let product2 = {productId:"HEARTS_1_2_H19",title:"A HANDFUL(aaa)", description:"of Bonus Hearts!", price:"$4.99"};
			let product3 = {productId:"HEARTS_1_1_H7", title:"A FEW", description:"Bonus Hearts!", price:"$1.99"};
			let product4 = {productId:"HEARTS_1_1_H6", title:"A FEW", description:"Bonus Hearts!", price:"$1.99"};
			let product6 = {productId:"HEARTS_1_1_H4", title:"A FEW", description:"Bonus Hearts!", price:"$1.99"};
			store.products.push(product1);
			store.products.push(product2);
			store.products.push(product3);
			store.products.push(product4);
			store.products.push(product6);
			store.productStoreReady = true;
		} else {
			console.log(`shakeproduct get-store called.`);
			window.WrapperApp.postMessage(`get-store`);
		}
	}

	startMusic() {
		return;

		// if(store.soundEnabled)
		// 	this.music.play( {
		// 		mute: false,
		// 		volume: 0.25,
		// 		rate: 1,
		// 		detune: 0,
		// 		seek: 0,
		// 		loop: true,
		// 		delay: 0
		// 	});
	}
	stopMusic() {
		this.music.stop();
	}
	playAudio(name) {
		if(store.settings.sound) {
			if(window.location.port === '3000' || window.location.hash === '#dev') {
				window.manager.playAudioSprite(name);
			} else if(window.WrapperApp) {
				if(name === 'bumper' && store.settings.vibration)
					name = 'bumperHaptic';
				window.WrapperApp.postMessage("play-sfx?name=" + name);

				// let rawJson = '{"cmd":"sfx_play","param":"'+name+'"}';
				// window.WrapperApp.postMessage(rawJson);
			}
		}
	}
	playAudioSprite(name) {
		console.log("PLAYING SFX: "+name);
		if(this.scene && this.scene.sound)
			this.scene.sound.playAudioSprite('sfx', name);
	}

	playHaptic(name = "haptic_mediumImpact", sfxName = "none") {
		if(store.settings.vibration) {
			if(window.location.port === '3000' || window.location.hash === '#dev') {
				console.log("running dev skipping haptic");
				if(sfxName !== 'none')
				window.manager.playAudio(sfxName);
			} else if(window.WrapperApp) {
				if(!store.settings.sound)
					sfxName = 'none';
				window.WrapperApp.postMessage("play-haptic?name=" + name+"&sfxName="+sfxName);
			}
		} else {
			if(sfxName !== 'none')
			window.manager.playAudio(sfxName);
		}
	}
	setSafeAreaBanners(top, bottom) {
		window.WrapperApp.postMessage("hud-banners?top="+top+"&bottom="+bottom);
	}

	getWrapperInfo() {
		window.WrapperApp.postMessage("get-info");
	}

	clearNextGameButtons(){
		if(this.ui.newGameContainer != null)
			this.ui.newGameContainer.destroy();
		if(this.ui.mainMenuButton != null)
			this.ui.mainMenuButton.destroy();
		this.cup.hideCup();
	}
	playfieldSetToBottom() {
		return;
		// this.playfield.y = this.playfieldHighPosition;
		// this.playfieldFrame.y = this.playfieldHighPosition;
		// this.scene.tweens.add({
		// 	targets     : [ this.playfield, this.playfieldFrame ],
		// 	y: this.playfieldHighPosition,
		// 	ease		  : 'Linear',
		// 	duration    : 150,
		// 	repeat      : 0,
		// 	completeDelay: 0,
		// 	onComplete: (tween, target ) => {},
		// });

	}
	playfieldStartScrolling() {
		return;
		// this.scene.tweens.add({
		// 	targets     : [ this.playfield, this.playfieldFrame ],
		// 	y: this.playfieldLowPosition,
		// 	ease		  : 'Linear',
		// 	duration    : 150,
		// 	repeat      : 0,
		// 	completeDelay: 0,
		// 	onComplete: (tween, target ) => {},
		// });

	}
}

// export const manager = new Manager();
